import { AnalyticsScreenProvider, OnboardingLayout } from "@wayflyer/flyui";
import type { FundingApplicationSchemas } from "api-types";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";

import { RevenueForm } from "../../components";
import { COMMON_MESSAGES } from "../../components/common-messages";
import { MESSAGES } from "../../components/revenue-form/message-definitions";
import { useFundingApplicationMutation } from "../../queries/funding-application/queries";

export interface RevenueEntryPageProps {
  onBack?: () => void;
  onContinue: (data: FundingApplicationSchemas.CustomerFundingApplicationState) => void;
}

const FORM_ID = "revenue-form";

export const RevenueEntryPage = ({ onContinue }: RevenueEntryPageProps) => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { isPending: isSubmitting } = useFundingApplicationMutation(customerDomain);

  return (
    <AnalyticsScreenProvider screen="onboarding-revenue-entry">
      <OnboardingLayout
        title={intl.formatMessage(MESSAGES.revenueFormHeading)}
        formId={FORM_ID}
        primaryActionType="submit"
        actions={{
          primary: {
            content: intl.formatMessage(COMMON_MESSAGES.nextLabel),
            analyticsId: "funder-revenue-form-submit",
            loading: isSubmitting,
            disabled: isSubmitting,
          },
        }}
      >
        <RevenueForm
          onContinue={(data) => {
            onContinue(data.applicationState);
          }}
          formId={FORM_ID}
        />
      </OnboardingLayout>
    </AnalyticsScreenProvider>
  );
};
